import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardsExclusivePill',
})
export default class CmgRewardsExclusivePill extends Vue {
  
  @Prop({ required: false, default: 'EXCLUSIVE', type: String })
  text?: string;

  get pepperBadgeUrl(): string {
    return this.$appStore.state.cms.images.icons.pepperBadge.default;
  }
}
